import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
import { styles } from './Kbd.styles';
export const Kbd = React.forwardRef(({ className, ...props }, forwardedRef) => {
    return _jsx("kbd", { className: cn(styles.root(), className), ...props, ref: forwardedRef });
});
